import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import { Cancel } from '@mui/icons-material';

const SubscriptionCancel = () => {
  const navigate = useNavigate();
  
  return (
    <Container maxWidth="md">
      <Box sx={{ my: 8 }}>
        <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Cancel color="error" sx={{ fontSize: 60, mb: 3 }} />
            <Typography variant="h4" gutterBottom>
              Subscription Not Completed
            </Typography>
            <Typography variant="body1" paragraph>
              You've canceled the subscription process. No charges have been made to your account.
            </Typography>
            <Typography variant="body2" color="text.secondary" paragraph>
              If you encountered any issues during checkout, please contact our support team.
            </Typography>
            
            <Box sx={{ mt: 4, display: 'flex', gap: 2 }}>
              <Button
                variant="outlined"
                onClick={() => navigate('/subscription/plans')}
              >
                Try Again
              </Button>
              <Button
                variant="contained"
                onClick={() => navigate('/venue/dashboard')}
              >
                Return to Dashboard
              </Button>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default SubscriptionCancel; 